// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2DH4i","file":"styles_file__2ard-"};